// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"I5-z"};